import classNames from 'classnames';
import PriceValue from 'components/Common/PriceValue/PriceValue';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getDeliveryDetails from 'store/product/selector/getDeliveryDetails';
import styles from './EstimatedShipmentPrice.module.scss';

interface OwnProps {
  theme?: string;
}

const EstimatedShipmentPrice: FC<OwnProps> = ({ theme }) => {
  const { t } = useTranslation();
  const deliveryDetails = useSelector(getDeliveryDetails);

  if (!deliveryDetails || !deliveryDetails.products || !deliveryDetails.products.length) {
    return null;
  }

  if (deliveryDetails.products[0].localProduction) {
    return null;
  }

  const shipmentPrice = deliveryDetails?.products[0].prices ? deliveryDetails?.products[0].prices[0] : undefined;

  if (!shipmentPrice) {
    return null;
  }

  return (
    <div className={classNames(styles.estimatedShipmentPrice, styles[`theme-${theme}`])}>
      <span>{t('txt_estimate_shipping')}:&nbsp;</span>
      <PriceValue price={shipmentPrice} theme={theme} />
    </div>
  );
};

export default EstimatedShipmentPrice;
